
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class ReOrderDetailsDialog extends Serenity.EntityDialog<ReOrderDetailsRow, any> {
        protected getFormKey() { return ReOrderDetailsForm.formKey; }
        protected getIdProperty() { return ReOrderDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return ReOrderDetailsRow.localTextPrefix; }
        protected getService() { return ReOrderDetailsService.baseUrl; }
        protected getDeletePermission() { return ReOrderDetailsRow.deletePermission; }
        protected getInsertPermission() { return ReOrderDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ReOrderDetailsRow.updatePermission; }

        protected form = new ReOrderDetailsForm(this.idPrefix);
        public atbid :number;
        constructor() {
            super();

            q.setTextRightAlign(this.form.Maximum0);
            q.setTextRightAlign(this.form.Maximum1);
            q.setTextRightAlign(this.form.Maximum2);
            q.setTextRightAlign(this.form.Minimum0);
            q.setTextRightAlign(this.form.Minimum1);
            q.setTextRightAlign(this.form.Minimum2);
            q.setTextRightAlign(this.form.Maximum0);
            q.setTextRightAlign(this.form.Maximum1);
            q.setTextRightAlign(this.form.Maximum2);
            q.setTextRightAlign(this.form.Minimum0);
            q.setTextRightAlign(this.form.Minimum1);
            q.setTextRightAlign(this.form.Minimum2);
            this.form.ProductTypeId.changeSelect2(e => {
                var baseitemid = parseInt(this.form.ProductTypeId.value);
                var itemtype = OMS.ProductTypeRow.getLookup().itemById[baseitemid].ItemTypeId;
                this.form.CategoryId.cascadeField = "ItemTypeId";
                this.form.CategoryId.cascadeValue = itemtype.toString();
                var typeid = parseInt(this.form.CategoryId.value);
                var subtypeid = parseInt(this.form.SubCategoryId.value);
                if (baseitemid != NaN && typeid != NaN && subtypeid != NaN)
                    this.validateAttribute(baseitemid, typeid, subtypeid);
            });
            this.form.CategoryId.changeSelect2(e => {
                var baseitemid = parseInt(this.form.ProductTypeId.value);
                var typeid = parseInt(this.form.CategoryId.value);
                var subtypeid = parseInt(this.form.SubCategoryId.value);
                this.form.SubCategoryId.cascadeField = "CategoryId";
                this.form.SubCategoryId.cascadeValue = typeid.toString();
                if (baseitemid != NaN && typeid != NaN && subtypeid != NaN)
                    this.validateAttribute(baseitemid, typeid, subtypeid);
            });
            this.form.SubCategoryId.changeSelect2(e => {
                var baseitemid = parseInt(this.form.ProductTypeId.value);
                var typeid = parseInt(this.form.CategoryId.value);
                var subtypeid = parseInt(this.form.SubCategoryId.value);
                if (baseitemid != NaN && typeid != NaN && subtypeid != NaN)
                    this.validateAttribute(baseitemid, typeid, subtypeid);
            });
            this.form.ProductTypeId.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                var x = this.form.Validate.value;
                if (this.form.Validate.value == false) {
                    Q.alert("Attributes already exist")
                    return "";
                }
            });
           // this.form.ProductId.se
            this.validateForm();
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isNew()) {
                this.form.Maximum0.value = 0;
                this.form.Maximum1.value = 0;
                this.form.Maximum2.value = 0;
                this.form.Minimum0.value = 0;
                this.form.Minimum2.value = 0;
                this.form.Minimum1.value = 0;
                this.form.Minimum0.value = 0;
                this.form.Minimum2.value = 0;
                this.form.Minimum1.value = 0;
                this.form.Maximum0.value = 0;
                this.form.Maximum1.value = 0;
                this.form.Maximum2.value = 0;
            }

        }
        validateAttribute(baseitemid: number, typeid: number, subtypeid: number) {
            var oldentity = ReOrderDetailsRow.getLookup().items.filter(x => x.ProductTypeId == baseitemid && x.CategoryId == typeid && x.SubCategoryId == subtypeid);
            let atbid: Common.CommonAttributeResponse;
            
            OMS.CommonAttributesService.GetProductATB(
                { ProductTypeId: baseitemid, CategoryId: typeid, SubCategoryId: subtypeid },
                response => {
                    atbid = response
                }, { async: false });
            if (atbid.AttributeId > 0) {
                this.atbid = atbid.AttributeId; 
            }
            if (oldentity.length > 0) {
                this.form.Validate.value = false;
                return false;

            } else {
                this.form.Validate.value = true;
                return true;    
            }
            
        }
    }
}